import type { PostMediaItem } from '@ps/api/types';
import { PopImage } from '@ps/ui/atoms/pop-image';

import { BlankedMedia } from './BlankedMedia';

interface Props {
  media: PostMediaItem;
  alt?: string;
  className?: string;
}

/**
 * IMAGE branch — {@link PopImage} (the sanctioned remote-image atom): `fill`s the
 * slide, cover-fits by default, and shows the media's blurhash while loading. A
 * restricted-and-blanked image (URL stripped) shows the {@link BlankedMedia}
 * blurhash preview instead, so nothing paid hits the wire. 1:1 with legacy
 * `MediaObjectView`'s image case (`slide-view.tsx:424-471`).
 */
export function PostImageMedia({ media, alt, className }: Props) {
  if (!media.url) {
    return (
      <BlankedMedia blurhash={media.metadata?.blurhash} className={className} />
    );
  }
  return (
    <PopImage
      src={media.url}
      alt={alt ?? media.caption ?? ''}
      fill
      blurhash={media.metadata?.blurhash}
      className={className}
      sizes="(min-width: 1024px) 540px, 100vw"
    />
  );
}
